(function($) {
    var trackingBinded = false;

    function bindTracking() {
        // Prevent double binding
        if(trackingBinded || typeof gtag === 'undefined') {
            return;
        }

        trackingBinded = true;

        // Tracking numéro de téléphone Cristal
        $('.tracking--cristal-number').on('click', function() {
            gtag('event', 'internal_click', {
                'target': 'clic_tel_cristal'
            });
        });

        // Tracking du formulaire de contact
        $(document).on('gform_confirmation_loaded', function() {
            gtag('event', 'valid_form_submit', {
                'target': 'form_contact'
            });
        })
    }

    $(function() {
        bindTracking();
    });
    $(window).on('gtag-loaded', bindTracking);
})(jQuery);